import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Filtro } from 'app/main/apps/shared/interfaces/filtro.interface';
import { Observable } from 'rxjs';
import { config as CONFIG } from "app/app.config";
import { MatChipInputEvent } from '@angular/material/chips';
import { FiltrosService } from 'app/main/apps/shared/services/util/filtros.service';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { ClienteDTO } from 'app/main/apps/shared/interfaces/cliente.interface';
import { FiltroCliente } from 'app/main/apps/shared/interfaces/filtro-cliente';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-searchbox',
  templateUrl: './searchbox.component.html',
  styleUrls: ['./searchbox.component.scss']
})
export class SearchboxComponent implements OnInit {

  @Output()
  filtrarCliente: EventEmitter<FiltroCliente> = new EventEmitter();
  filtros: FiltroCliente;

  @ViewChild("estadoInput") estadoInput: ElementRef<HTMLInputElement>;
  @ViewChild("clienteInput") clienteInput: ElementRef<HTMLInputElement>;

  @Input() estados: Filtro[];
  @Input() clientes: ClienteDTO[];

  filteredEstados: Observable<any[]>;
  filteredClientes: Observable<ClienteDTO[]>;

  estadoCtrl = new FormControl();
  clienteCtrl = new FormControl();

  config;

  constructor(private _filtroSrvc: FiltrosService) { 
    this.config = CONFIG;
    this.filtros = this._filtroSrvc.getFiltro("filtrosClientes");

    this.filteredClientes = this.clienteCtrl.valueChanges.pipe(
      startWith(null),
      map((value: string | null) =>
          value
              ? this._filter(value, "nombre", this.clientes)
              : this.clientes.slice()
      )
    );

    this.filteredEstados = this.estadoCtrl.valueChanges.pipe(
      startWith(null),
      map((value: string | null) =>
          value
              ? this._filter(value, "descripcion", this.estados)
              : this.estados.slice()
      )
    );


  }

  ngOnInit(): void {
  }


  private _filter(
    value: string | any,
    columnaAFiltrar: string,
    listaDeValoresAfiltrar: any[]
  ): any[] {
    let filterValue: string;
    if (typeof value === "object") {
        filterValue = value[columnaAFiltrar].toLowerCase();
    } else {
        filterValue = value.toLowerCase();
    }

    return listaDeValoresAfiltrar.filter((item) =>
        item[columnaAFiltrar].toLowerCase().includes(filterValue)
    );
  }

  agregarFiltro(
    event: MatChipInputEvent,
    controller: any,
    filtroSeleccionado: string
  ) {
    const input = event.input;
    const value = event.value;
    if ((value || "").trim()) {
        this._filtroSrvc.setFiltro(
            "filtrosFacturas",
            filtroSeleccionado,
            value.trim(),
            value.trim()
        );
    }

    if (input) {
        input.value = "";
    }

    controller.setValue(null);
  }

  seleccionarFiltro(
    event: MatAutocompleteSelectedEvent,
    columnaValor: string,
    columnaDescripcion: string,
    controller: any,
    input: string,
    filtroSeleccionado: string
) {
    const valor = event.option.value[columnaValor];
    const descripcion = event.option.value[columnaDescripcion];

    this._filtroSrvc.setFiltro(
        "filtrosClientes",
        filtroSeleccionado,
        valor,
        descripcion
    );
    this[input].nativeElement.value = "";
    controller.setValue(null);
    this.filtros = this._filtroSrvc.getFiltro("filtrosClientes");
  }

  limpiarTodosFiltros() {
    this._filtroSrvc.initFiltrosCliente();
    this.filtros = this._filtroSrvc.getFiltro("filtrosClientes");
    this.filtrar();
  }

  
  
  quitarFiltro(nombreFiltro: string) {
    this._filtroSrvc.resetFiltro("filtrosClientes", nombreFiltro);
  }
  
  
  filtrar() {
    this.filtrarCliente.emit(this.filtros);
  }
}
